import { NgModule } from '@angular/core';
import { SafePipe } from './safe.pipe';


export class SafePipeModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [ SafePipe ],
  exports: [ SafePipe ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
